<h2 mat-dialog-title class="text-center ">
	<mat-icon class="icon-{{ data.type }}">{{ iconType }}</mat-icon>
	<span class="block text-white">{{data.title}}</span>
</h2>
<mat-dialog-content>
  	<p class="text-center text-white">{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  	<button matButton (click)="onConfirm()">Aceptar</button>
</mat-dialog-actions>